/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "social-linkedin-square-inline-9f25adbe--sprite",
  "use": "social-linkedin-square-inline-9f25adbe--sprite-usage",
  "viewBox": "0 0 19 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 19\" id=\"social-linkedin-square-inline-9f25adbe--sprite\"><path d=\"M211.595,88H195.4a1.386,1.386,0,0,0-1.4,1.37v16.259A1.387,1.387,0,0,0,195.4,107h16.193A1.39,1.39,0,0,0,213,105.629V89.37A1.389,1.389,0,0,0,211.595,88Zm-11.958,16.191h-2.821V95.123h2.821Zm-1.41-10.306a1.634,1.634,0,1,1,1.634-1.635A1.634,1.634,0,0,1,198.227,93.884Zm11.965,10.306h-2.818v-4.41c0-1.051-.018-2.4-1.465-2.4-1.466,0-1.69,1.146-1.69,2.329v4.485H201.4V95.123h2.7v1.24h.039a2.96,2.96,0,0,1,2.666-1.465c2.853,0,3.381,1.877,3.381,4.319Z\" transform=\"translate(-194 -88)\" fill=\"currentColor\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
